import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const Tonnage = (props) => {
  return (
    <FormGroup controlId="tonnage">
      <Col componentClass={ControlLabel} sm={5}>
        Tonnage *
      </Col>
    <Col sm={7}>
        <FormControl
          type="number"
          value={props.tonnage}
          onChange={props.handleChangeTonnage}
          onBlur={props.calculation}
          required
          autoComplete="off"
          max="99999"
          min="0"
          step="0.1" />
    </Col>
    </FormGroup>
  )
}

Tonnage.propTypes = {
  tonnage: PropTypes.number,
  handleChangeTonnage: PropTypes.func,
  calculation: PropTypes.func
};

export default Tonnage;



// WEBPACK FOOTER //
// ./src/app/components/tonnage/Tonnage.js